import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-phone3.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { PaystackButton } from "react-paystack"

export const PaystackPayment = () => {

    const [email, setEmail] = useState("")
    const [name, setName] = useState("")
    const [phone, setPhone] = useState("")
    const [amount, setAmount] = useState("")
    const[course_title, setCourseTitle] = useState("")
    const [receipt, setReceipt] = useState(false)
    const publicKey = "pk_live_32cba88ca2dcc9c45269a49559787aa1a6a55964"

    const showReceipt = () => {
        setTimeout(() => {
            window.location.reload(); 
        }, 3000)
    }

  const componentProps = {
    email,
    amount,
    metadata: {
      name,
      phone,
      course_title,
    },
    publicKey,
    text: "Pay Now",
    onSuccess: () => {setReceipt(true); showReceipt()},
    onClose: () => alert("Wait! If you leave the transaction will be cancelled"),
  };

    
  
  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h3 className="contt">Enter Payment Details</h3>
                <p className="chris">Please Enter the Desired Package(s) Titles(s) in The Box.</p>
                <p>* Mobile App Development Training = N10,000 (Promo ongoing 90%: Pay N1050 Only)</p>
                <p>* Full Stack (MERN) Development Training = N30,000</p>
                <p>* 30 Days Master Class Graphics Design 201 Advance Training = N20,000</p>
                <p>* Graphic Design = N2,000</p>
                <p>* Others (Please Specify)</p>
                <p className="chris">Sum Total when paying for more than one course.</p><br />

                <form>
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" required='true' placeholder="Full Name" name="name" id="name" onChange={(e) => setName(e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="email" required='true' placeholder="Email Address" name="email" id="email" onChange={(e) => setEmail(e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="tel" required='true' placeholder="Phone No." name="phone" id="phone" onChange={(e) => setPhone(e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" required='true' placeholder="Course(s) Title(s)" name="course_title" id="course_title" onChange={(e) => setCourseTitle(e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="number" required='true' placeholder="Amount" name="amount" id="amount" onChange={(e) => setAmount(e.target.value * 100)} />
                    </Col>
                    </Row>
                  
                </form>
                
                <PaystackButton {...componentProps} 
                className="paystack-p"
                />

                {receipt && <p className="paystack-p2">Receipt Has been sent to your email</p>}             
               
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

// test Secreate Key: sk_test_197dcdd88d4e5d1126132ade81f082148b981d49

// test Public Key: pk_test_ce3becdbd917d77292665073fccbc6de12dfa5b8
